export default "__VITE_ASSET__DHPEI4wv__"